<!--
 * @创建文件时间: 2019-11-06 11:36:57
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-10 12:18:01
 * @联系Qq:1638245306
 * @文件介绍: 
 -->
<template>
  <div style="background: #fff;">
       <el-row>
     <el-checkbox v-model="allChecked" @change="handleCheckAllChange">全选</el-checkbox>
      </el-row>
    <el-tree
      style="height:500px;overflow-y:scroll;"
       ref='tree'
      :props='treeConfig'
      :data='treeData'
      :node-key="nodeKey"
      :default-checked-keys="defaultCheckedKeys"
      show-checkbox
      :check-strictly="true"
      @check="clicks">
    </el-tree>
  </div>
</template>
<script>
  export default {
    name:'DynamicTree',
    data() {
      return {
        checkedList:[],
        count: 1,
        allChecked:false,
        selectId:'',
        treeIdList:[],
      };
    },
    props:{
      nodeKey:{
        type:String,
        default:'id'
      },
       defaultCheckedKeys:{
        type:Array,
        default:()=>[]
      },
      treeData:{
        type:Array,
        default:()=>[]
      },
      treeConfig:{
        type:Object,
        default:()=>{
          return{
            'label':'label',
            'children':'children'
          }  
        }
      }
    },
    watch: {
    },
    methods: {
      //获取选中项
      clicks(data,notes){
        if(notes.checkedKeys.indexOf(data.id)>=0){
          if(this.selectId!=data.id){
            let datas=data;
            let arr=this.factorial(datas);
            arr.forEach(element => {
              this.defaultCheckedKeys.push(element);
            });
            this.selectId=data.id;
          }else{
            this.defaultCheckedKeys.push(data.id);
            this.selectId='';
          }
          ((data.pId!=0)&&(notes.checkedKeys.indexOf(data.pId)<0))&&(this.defaultCheckedKeys.push(data.pId));
          (this.defaultCheckedKeys.length==this.treeIdList.length)&&(this.allChecked=true)
          this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
        }else{
            let datas=data;
            let arr=this.factorial(datas);
            let arrs=this.defaultCheckedKeys;
            arr.forEach(element => {
              let indexs=arrs.indexOf(element);
              (indexs!='-1')&&(arrs.splice(indexs,1));
            });
            this.defaultCheckedKeys=arrs;
            this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
            this.allChecked=false;
        }
        this.checkedList = this.defaultCheckedKeys
        this.$emit('setChecked',this.checkedList)
      },
      handleCheckChange(data, checked, indeterminate) {
      },
      handleCheckAllChange(){
        let that = this
        if(that.allChecked){
          if(this.defaultCheckedKeys.length!=this.treeIdList.length){
            let arrs=this.treeIdList;
            this.defaultCheckedKeys.splice(0,this.defaultCheckedKeys.length);
            arrs.forEach(element => {
              this.defaultCheckedKeys.push(element);
            });
            that.$refs.tree.setCheckedKeys(arrs);
          }
        }else{
          if(this.defaultCheckedKeys.length==this.treeIdList.length){
            this.defaultCheckedKeys.splice(0,this.defaultCheckedKeys.length);
            that.$refs.tree.setCheckedKeys([]);
          }
        }
        this.checkedList = this.defaultCheckedKeys
        this.$emit('setChecked',this.checkedList)
      },
      factorial(val){
        let lists=[];
        let nums=val;
        let func=(function f(num){
          lists.push(num.id)
          if(num.children.length>0){
            num.children.forEach(element=>{
              let g=element;
              return f(g)
            })
          }else{
            return 0
          }
        })
        func(nums);
        return lists
      },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      if(this.treeIdList.length==0){
        let arrs=[];
        this.treeData.forEach(element => {
          let a=this.factorial(element);
          arrs=arrs.concat(a);
        });
        this.treeIdList=arrs;
      }
    },
  };
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Tables/DynamicTree.vue"
}
</vue-filename-injector>
